module.exports = __webpack_public_path__ + "img/aqi_lv6.00e9d191.png";